import { onBeforeUnmount, onMounted, watch, type Ref } from 'vue';
import { lockScroll, unlockScroll } from '~/utils/scrollLock';

// Lock the page behind an overlay for as long as the overlay is open.
//
//   useScrollLock()               — locked while the component is mounted
//                                   (an overlay rendered with v-if)
//   useScrollLock(isOpenRef)      — locked while the ref is true (an overlay
//                                   kept mounted and shown with v-show)
//
// Use this instead of setting `document.body.style.overflow`, which iOS Safari
// ignores and which one overlay's close would undo for another still open.
export function useScrollLock(active?: Ref<boolean> | (() => boolean)) {
    let held = false;

    const set = (on: boolean) => {
        if (on === held) return;
        held = on;
        if (on) lockScroll();
        else unlockScroll();
    };

    onMounted(() => {
        if (active === undefined) set(true);
        else watch(active, (on) => set(!!on), { immediate: true });
    });

    onBeforeUnmount(() => set(false));
}
